export default "__VITE_ASSET__odJW$NxM__"